module.exports = __webpack_public_path__ + "static/media/iphone_12_purple.7d0eacb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_purple.png
// module id = 2092
// module chunks = 0